import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, GetMethodResponse, ListMethodArg, ListMethodResponse, ModelClass, References } from '/imports/types';
import { validateNumber, validateString } from '/imports/validators';
import { strings } from '/imports/strings';

export interface Interconnection extends Doc {
  productionMeterId: string;
  consumptionMeterId: string;
  weight: number;
}
export type Model = Interconnection;

export const Interconnections = new Mongo.Collection<Interconnection>('interconnections');

type Refs = References<Model>

export const modelClass: ModelClass<Model, Refs> = {
  collection: Interconnections,
  editableFields: ['active', 'productionMeterId', 'consumptionMeterId', 'weight'],
  fieldLimits: {
    'consumptionMeterId': 64, 'productionMeterId': 64,
  },
  listMethod: DeclareMethod<ListMethodArg<Interconnection>, ListMethodResponse<Interconnection, Refs>>('listInterconnections'),
  getMethod: DeclareMethod<string, GetMethodResponse<Interconnection, Refs>>('getInterconnection'),
  createMethod: DeclareMethod<Partial<Interconnection>, string>('createInterconnection'),
  updateMethod: DeclareMethod<Partial<Interconnection>, string>('updateInterconnection'),
  deleteMethod: DeclareMethod<string>('deleteInterconnection'),
  pathPrefix: '/interconnections',
  asString: (document) => `${document.productionMeterId} → ${document.consumptionMeterId}`,
  modelName: strings.Interconnection(),
  pluralName: strings.Interconnections(),
  searchQuery: (search?: string) => {
    search = search?.trim();
    if (!search?.length) return {};
    return {
      $or: [
        { _id: search },
        { productionMeterId: search },
        { consumptionMeterId: search },
      ]
    };
  },
  validate: async (document: Partial<Interconnection>) => {
    const errors: { [key: string]: string[] } = {};
    validateString(errors, document, 'productionMeterId', { required: true });
    validateString(errors, document, 'consumptionMeterId', { required: true });
    validateNumber(errors, document, 'weight', { required: true });
    return errors;
  },
};

Meteor.isServer && Meteor.startup(async () => {
  await Interconnections.createIndexAsync({ productionMeterId: 1 });
  await Interconnections.createIndexAsync({ consumptionMeterId: 1 });
  await Interconnections.createIndexAsync({ productionMeterId: 1, consumptionMeterId: 1 }, { unique: true });
});
